import XGrid from "@/components/grid/XGridTree";
import {treeList, delTreeList} from "@/services/dataSource";
import XEUtils from "xe-utils";
import {mapGetters} from "vuex";
import {CONSTANT as constant} from '@/services/constant';
import api from '@/services/api'

const GridTreeMinix = {
	name: 'xGridTreeList',
	components: {
		XGrid,
	},
	/**
	 * 将当前用户加载到页面中
	 */
	computed: {
		...mapGetters('account', ['user'])
	},
	data() {
		return {
			params: this.$route.query,
			api,
			constant,
			popConfig: {},
			url: '',
			delUrl: '',
			parentId: 'parentId',
			childParent: {},//新建子节点时父节点的数据
			dataRow: {},//新建子节点时父节点的数据/编辑子节点时子节点的数据
			editRowId: 0,//编辑单据主键
			editModalVisible: false,
		}
	},
	methods: {
		/**
		 * 打开加载/关闭加载
		 * @param status
		 */
		loading(status) {
			this.$refs['grid'].loading = !!status;
		},
		/**
		 * 子表弹出层
		 * @param row
		 * @param type
		 * @param many
		 */
		openPop(row, type, many) {
			if (many) {
				this.popConfig[type].id = row.map(v => {
					return v[this.rowId]
				});
				this.popConfig[type].row = row;
				this.popConfig[type].show = true;
				this.dataRow = row;
			} else {
				this.popConfig[type].id = row[this.rowId];
				this.popConfig[type].row = row;
				this.popConfig[type].show = true;
				this.dataRow = row;
			}
		},
		closePop(type) {
			this.popConfig[type].id = -1;
			this.popConfig[type].row = {};
			this.popConfig[type].show = false;
			this.dataRow = {};
		},
		closePopAndRefresh() {
			for (let item in this.popConfig) {
				this.popConfig[item].id = -1;
				this.popConfig[item].row = {};
				this.popConfig[item].show = false;
			}
			this.dataRow = {};
			this.refresh()
		},

		/**
		 * 工具栏的弹出层处理
		 * @param type
		 * @param many 是否是多条
		 * @param other 自定义判断
		 */
		chooseOpenPop(type, many, other) {
			let row = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
			if (!many) {
				if (row.length !== 1) {
					this.$message.error('请选择一条数据');
					return;
				}
				if (typeof other === 'function') {
					other(row[0], type);
				} else {
					this.openPop(row[0], type);
				}
			} else {
				if (row.length < 1) {
					this.$message.error('请至少选择一条数据');
					return;
				}
				if (typeof other === 'function') {
					other(row, type);
				} else {
					this.openPop(row, type, true);
				}
			}
		},

		/**
		 * 获取被选中的数据
		 */
		getRows() {
			return this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
		},

		/**
		 * 树列表默认禁用掉双击 有需要可重写
		 */
		cellDbClick() {
		},
		/**
		 * 表单方法
		 */
		//新建子节点
		newChild(row) {
			this.dataRow = row;
			this.childParent = row;
			this.editRowId = 0;
			this.editModalVisible = true;
		},
		addRow() {
			this.dataRow = {};
			this.openEdit(0);
		},
		updateRow(row) {
			this.dataRow = row;
			this.editRow(row)
		},
		editRow(row) {
			this.openEdit(row[this.rowId]);
		},
		openEdit(keyId) {
			this.editRowId = keyId;
			this.editModalVisible = true;
		},
		closeEdit(refresh) {
			if (refresh === true) {
				this.refresh();
			}
			this.dataRow = {};
			this.editRowId = -1;
			this.childParent = {};
			this.editModalVisible = false;
		},
		refresh() {
			this.loadData().then(() => {
			})
		},
		delRow(row) {
			delTreeList(this.delUrl || this.url, row[this.rowId]).then(() => {
				// this.$refs['grid'].$refs['xGrid'].remove(row);
				this.$message.success('删除成功');
				this.loadData().catch();
			}).catch(error => {
				this.$message.error(error.response.response.data.msg)
			});
		},
		async loadData() {//刷新
			this.loading(true);
			let arr = await treeList(this.url).catch(e => {
				this.$message.error(e.msg)
			});
			this.loading(false);
			this.$refs['grid'].$refs['xGrid'].reloadData(XEUtils.toArrayTree(arr.data, {
				key: this.rowId,
				parentKey: this.parentId,
				children: 'children'
			}));
		},

	}
}

export {
	GridTreeMinix
}